/* eslint-disable import/prefer-default-export */
import React from "react";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import {
  useGetRoleAndNameQuery
} from "../../services/admin.service";

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
export const SignOutButton = () => {
  const { data: { body: names = [] } = {} } = useGetRoleAndNameQuery();
  const { t } = useTranslation();
  const { instance } = useMsal();
 

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
    // localStorage.clear();
    sessionStorage.setItem("KKFGroups", JSON.stringify(names?.groups));
  };

  return (
    <span>
      <span style={{ cursor: "pointer" }} onClick={handleLogout}>
        <Button
          className="btn btn-danger"
          style={{ width: "100%" }}
        >
          <i
            className="mdi mdi-logout-variant rounded-circle me-1"
            alt="mdo"
            width="35"
            height="35"
          ></i>{" "}
        {t("signout")}
        </Button>
      </span>
    </span>
  );
};
